<template>
  <vv-desktop-taste-tile
    :title="tasting.bottleName"
    :ratingPath="this.tasting.id"
    :status="status"
    :image="tasting.tileImage"
    :bottleId="tasting.bottleId"
    :rating="rating"
    @click="openTasting"
    v-if="$mq == 'desktop'"
  />
  <vv-mobile-taste-tile
    :title="tasting.bottleName"
    :fontSize="fontSize"
    :image="tasting.tileImage"
    :status="status"
    :ratingPath="this.tasting.id"
    :bottleId="tasting.bottleId"
    :rating="rating"
    :mini="mini"
    @click="openTasting"
    v-else
  />
</template>

<script>
import get from 'lodash/get'
import { mapGetters } from 'vuex'

import VvMobileTasteTile from '@/components/common/VvMobileTasteTile'
import VvDesktopTasteTile from '@/components/common/VvDesktopTasteTile'

export default {
  name: 'TastingListItem',
  components: { VvMobileTasteTile, VvDesktopTasteTile },

  props: {
    id: {
      type: String,
      required: true
    },
    mini: {
      type: Boolean,
      require: false
    }
  },
  data() {
    return {
      fontSize: 0
    }
  },
  mounted() {
    let bottleTitle = this.getTastingById(this.id).bottleName
    let tooLong = bottleTitle.split(' ').some(word => {
      return word.length > 8
    })
    this.fontSize = tooLong ? 18 : 22
  },
  computed: {
    ...mapGetters({ getTastingById: 'getTastingById' }),

    tasting() {
      return this.getTastingById(this.id)
    },
    ratingpath() {
      return 'tasting/' + this.tasting.id + '/rating'
    },
    status() {
      const status = get(this.$store, ['state', 'completion', 'tasting', this.id], null)
      return status
    },
    rating() {
      const tmp = get(this.$store, ['state', 'completion', 'tasting', this.tasting.id], null)
      return tmp && tmp['rating'] ? parseInt(tmp['rating']) : 0
    }
  },
  methods: {
    openTasting() {
      this.$router.push({ name: 'tasting-question', params: { tastingId: this.id } })
    }
  }
}
</script>
